import React from 'react';
import { records as appStorageRecords } from '@saucelabs/sl-module-app-storage';
import { Typography } from '@saucelabs/ds-typography';

import constants from '../../../constants';

const {
  DAYS_BEFORE_SHOWING_DELETION_LABEL_THRESHOLD,
} = constants;

type TableCellUploadedProps = {
  file: appStorageRecords.AppStorageFile,
};

const TableCellUploaded: React.FC<TableCellUploadedProps> = ({ file }) => (
  <>
    <Typography
      data-qa="app-management-files-table-cell-uploaded-label"
    >
      {file.getCreationDateShortLabel()}
    </Typography>
    {file.getDaysUntilDeletion() < DAYS_BEFORE_SHOWING_DELETION_LABEL_THRESHOLD && (
      <Typography
        className="text-red-900"
        data-qa="app-management-files-table-cell-uploaded-deletion-notice"
        variant="body-small"
      >
        {file.getDeletionDatePrettyLabel()}
      </Typography>
    )}
  </>
);

export default TableCellUploaded;
